import SVGChecklist from 'components/_common/icons/SVGChecklist';
import SVGEngineLog from 'components/_common/icons/SVGEngineLog';
import SVGPermit from 'components/_common/icons/SVGPermit';
import React, { FC } from 'react';
import { EBookType, IBook } from 'redux/app/vessel/types';

interface IBookProps extends IBook { }

function getBgColor(bookType: EBookType): string {
	switch (bookType) {
		case EBookType.CHECKLIST:
			return '#43A047';
		case EBookType.LOG:
			return '#1b4ea3';
		case EBookType.PERMIT:
			return '#E89B03';
		case EBookType.MARPOL:
			return '#1b4ea3';
		default:
			return '';
	}
}

function getIcon(bookType: EBookType): JSX.Element {
	switch (bookType) {
		case EBookType.CHECKLIST:
			return <SVGChecklist />;
		case EBookType.LOG:
			return <SVGEngineLog />;
		case EBookType.PERMIT:
			return <SVGPermit />;
		case EBookType.MARPOL:
			return <SVGEngineLog />;
		default:
			return <></>;
	}
}

const Book: FC<IBookProps> = (props) => {
	const { title, bookType } = props;
	return (
		<div
			style={{
				backgroundColor: getBgColor(bookType),
			}}
			className="rounded-lg py-5 px-2 lg:py-10 lg:px-5 flex flex-col items-center gap-y-[14px]"
		>
			<span className='lg:block hidden'>
				{getIcon(bookType)}
			</span>
			<span className="lg:text-base text-sm font-bold leading-6 tracking-wide text-white">
				{title}
			</span>
		</div>
	);
};

export default Book;
